function SvgComponent(props: any) {
    return (
      <svg
        width={157}
        height={96}
        viewBox="0 0 157 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 9.5A9.5 9.5 0 0128.5 0h79a9.5 9.5 0 019.5 9.5 9.5 9.5 0 01-9.5 9.5h-.753A9.5 9.5 0 01112 27.5a9.5 9.5 0 01-9.5 9.5H137c5.523 0 10 4.477 10 10s-4.477 10-10 10h-26.417c4.663.745 8.225 4.785 8.225 9.658 0 4.39-2.892 8.105-6.876 9.342H147c5.523 0 10 4.477 10 10s-4.477 10-10 10H10C4.477 96 0 91.523 0 86s4.477-10 10-10h38.588c-3.983-1.237-6.876-4.952-6.876-9.342 0-4.873 3.563-8.913 8.225-9.658H33c-5.523 0-10-4.477-10-10s4.477-10 10-10h20.5a9.5 9.5 0 01-4.247-18H28.5A9.5 9.5 0 0119 9.5z"
          fill="#F9F8FF"
        />
        <circle cx={21} cy={50} r={2} fill="#5627FF" />
        <circle cx={130} cy={66} r={2} fill="#5627FF" />
        <path
          d="M146.703 62.854l-.203-.281-.203.28-2.165 3-.286.397h5.308l-.286-.396-2.165-3zM121.717 11.875l-.217-.375-.217.375-2.165 3.75-.216.375h5.196l-.216-.375-2.165-3.75z"
          stroke="#5627FF"
          strokeWidth={0.5}
        />
        <path
          d="M74 28a5 5 0 00-5 5v13.017a13.698 13.698 0 012.5-.462V33a2.5 2.5 0 012.5-2.5h10v8.75A3.75 3.75 0 0087.75 43h8.75v20a2.5 2.5 0 01-2.5 2.5h-9a13.768 13.768 0 01-1.642 2.5H94a5 5 0 005-5V41.535a3.75 3.75 0 00-1.1-2.65l-9.785-9.787A3.75 3.75 0 0085.465 28H74zm21.983 12.5H87.75a1.25 1.25 0 01-1.25-1.25v-8.233l9.483 9.483zM84 59.25a11.25 11.25 0 10-22.5 0 11.25 11.25 0 0022.5 0zm-11.25 4.7a1.563 1.563 0 110 3.126 1.563 1.563 0 010-3.126zm0-12.193c2.578 0 4.632 2.116 4.632 4.876 0 1.464-.535 2.27-1.817 3.297l-.692.535c-.616.485-.823.75-.866 1.12l-.027.39a1.25 1.25 0 01-2.48-.225c0-1.425.525-2.21 1.79-3.22l.695-.538c.72-.575.9-.854.9-1.36 0-1.395-.955-2.374-2.135-2.374-1.235 0-2.147.914-2.132 2.362a1.25 1.25 0 01-2.5.025c-.028-2.843 2.012-4.888 4.632-4.888z"
          fill="#5627FF"
        />
      </svg>
    )
  }
  
  export default SvgComponent
  